import { Editor } from "@tinymce/tinymce-react";

/**
 * Éditeur de texte riche (TinyMCE auto-hébergé, voir le script postinstall).
 * Compatible Form.Item d'antd : reçoit `value` et `onChange`.
 */
const RichTextEditor = ({ value, onChange, height = 420 }) => (
    <Editor
        tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
        licenseKey="gpl"
        value={value ?? ""}
        onEditorChange={(content) => onChange?.(content)}
        init={{
            height,
            menubar: false,
            branding: false,
            promotion: false,
            plugins: "lists link table code autoresize",
            toolbar:
                "undo redo | blocks | bold italic underline | bullist numlist | link table | removeformat | code",
            block_formats: "Paragraphe=p; Titre 2=h2; Titre 3=h3; Titre 4=h4",
            autoresize_bottom_margin: 20,
            min_height: height,
            content_style: "body { font-family: system-ui, sans-serif; font-size: 15px; line-height: 1.6; }",
        }}
    />
);

export default RichTextEditor;
